module.exports = __webpack_public_path__ + "static/media/the-promised-land-tablet.15c9c06c.jpg";